module.exports = __webpack_public_path__ + "media/asset-2.336b2c54.mp4";